export {};

declare global {
  interface String {
    /**
     * Splits a string on spaces, lowercase the string, and title cases the parts
     * @returns {string}
     */
    ucWords();

    /**
     * Lowercase a string and capitalizes the first letter
     * @param {boolean} lowerCase lowercases the string by default. Pass in false to keep the string format
     * @returns {string}
     */
    capitalizeFirstLetter(lowerCase?: boolean);

    /**
     * Pass in an array of strings to find and replace on a string. Will replace with the same index on the replace array. If no index is found it will replace with a blank string
     * Based on https://stackoverflow.com/a/5069776
     * @param {any} find
     * @param {any} replace
     */
    replaceArray(find: any, replace?: any);

    /**
     * Transforms a camel case string to a regular form string
     * E.g. thisIsAString -> This Is A String
     * Based on https://stackoverflow.com/a/4149393
     */
    camelToRegular();

    /**
     * Transforms a camel case string to a hyphen separated string
     * E.g. thisIsAString -> this-is-a-string
     */
    camelToHyphen();

    /**
     * Replaces the - with / for dates as Safari doesn't understand dashes
     */
    iosDateSafeFormat();
  }
}

/**
 * Splits a string on spaces, lowercase the string, and title cases the parts
 * @returns {string}
 */
String.prototype.ucWords = function(): string {
  const arr = this.split(' ').map((val) => {
    return val.toLowerCase().capitalizeFirstLetter();
  });
  return arr.join(' ');
};

/**
 * Lowercase a string and capitalizes the first letter
 * @param {boolean} lowerCase
 * @returns {string}
 */
String.prototype.capitalizeFirstLetter = function(lowerCase: boolean = true): string {
  lowerCase && this.toLowerCase();
  return this.charAt(0).toUpperCase() + this.slice(1);
};

/**
 * Pass in an array of strings to find and replace on a string. Will replace with the same index on the replace array. If no index is found it will replace with a blank string
 * Based on https://stackoverflow.com/a/5069776
 * @param {any} find
 * @param {any} replace
 *
 * @returns {string}
 */
String.prototype.replaceArray = function(find, replace = []): string {
  let replaceString = this;
  find.forEach((value, index) => {
    replaceString = replaceString.replace(value, replace[index] || '');
  });
  return replaceString;
};

String.prototype.camelToRegular = function() {
  return this.replaceArray([/([A-Z])/g, /^./], [' $1', (str) => str.ucWords()]);
};

String.prototype.camelToHyphen = function() {
  return this.replaceArray([/([A-Z])/g, /.*/], ['-$1', (str) => str.toLowerCase()]);
};

String.prototype.iosDateSafeFormat = function() {
  return this.replaceArray([/-/g, /\.\d+/], '/');
};



// WEBPACK FOOTER //
// ./src/utils/string/string-prototype.utils.ts